import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=b85e95c0&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85e95c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b85e95c0')) {
      api.createRecord('b85e95c0', component.options)
    } else {
      api.reload('b85e95c0', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=b85e95c0&scoped=true&", function () {
      api.rerender('b85e95c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gIk3TBjULCZv/JS/comp/Voucher-Unit.vue"
export default component.exports